import { useEffect } from "react";
import { ProcessosProvider } from "../../contexts/Processos";
import { DadosContainerDefault } from "../../components/Styles";
import BancoIndicadores from "../../components/BancoIndicadores";

function BancoIndicadoresPage() {
  useEffect(() => {
    document.title = 'Banco de Indicadores | Gesttor'
  })
  return (
    <ProcessosProvider>
      <DadosContainerDefault>
        <BancoIndicadores />
      </DadosContainerDefault>
    </ProcessosProvider>
  );
}

export default BancoIndicadoresPage;